import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = ({ items = MARQUEE_ITEMS }) => {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-[#C9A55C]/15 py-6 bg-[#0D1018]" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-accent italic text-xl sm:text-2xl text-[#F3EEE5]/70 px-6">{item}</span>
            <span className="text-[#C9A55C] text-xs">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
